import { useContext, useEffect, useState } from "react"
import { checkValidPassword, getLedgerHistory, getNotification } from "../../services/settingsService"
import moment from "moment";
import { Interweave } from "interweave";
import { ClientProfileContext, IsViewLockUpdateFlag, SwalContext } from "../../layout/BaseLayout";
import Draggable from "react-draggable";
import Modal from "react-bootstrap/Modal";
import { ModalDialog } from "react-bootstrap";

const passModal = (props) => {
  return (
    <Draggable handle=".modal-header">
      <ModalDialog {...props} />
    </Draggable>
  );
};

export default function Ledger(props) {
  let userAuthData = localStorage.getItem("curLogin");
  userAuthData = JSON.parse(userAuthData);
  let [clientDetails, setClientDetails] = useContext(ClientProfileContext);
  let Swal = useContext(SwalContext)
  const [isUnlockAllPages, setIsUnlockAllPages] = useContext(IsViewLockUpdateFlag);
  const [view, setView] = useState('list');
  const [startDate, setStartDate] = useState(moment(getPreviousDay()).format('YYYY-MM-DD'));
  const [endDate, setEndDate] = useState(moment(new Date()).format('YYYY-MM-DD'));
  const [dateType, setDateType] = useState("");
  const [list, setList] = useState("");
  const [selectedMsg, setSelectedMsg] = useState({});
  const serverTimeZone = !!localStorage.getItem('timezone') ? JSON.parse(localStorage.getItem('timezone'))?.value : "";
  const [status, setStatus] = useState(!(isUnlockAllPages || userAuthData?.isViewLocked) ? 1 : 0);
  const [showPassModal, setShowPassModal] = useState(true);
  const [password, setPassword] = useState("");
  const [showPass, setShowPass] = useState(false);

  function getPreviousDay(date = new Date()) {
    const previous = new Date(date.getTime());
    previous.setDate(date.getDate() - 1);

    return previous;
  }

  const loadList = () => {
    let objHistory = Object();
    // objHistory["userName"] = clientId
    // objHistory["userRole"] = "Client"
    objHistory["fromDate"] = startDate
    objHistory["toDate"] = endDate
    getLedgerHistory(objHistory).then((res) => {
      if (res.isSuccess) {
        setList(res.data);
      }
    })
  };

  const submitPassword = () => {
    var tyepLogin = "USER";
    if (userAuthData?.isreadonlypassword) {
      tyepLogin = "INV";
    }

    let body = {
      "type": tyepLogin,
      "password": password,
      "clientId": userAuthData?.loginid
    }
    checkValidPassword(body).then((res) => {
      if (!res?.data?.status) {
        // Swal.fire({
        //   showConfirmButton: true,
        //   text: res?.data?.msg[0],
        //   confirmButtonColor: '#3085d6',
        //   confirmButtonText: 'Ok'
        // })

        let details = { ...clientDetails["clientDetails"], isViewLocked: true };
        setClientDetails({
          ...clientDetails,
          clientDetails: details
        });
      }

      if (res?.data?.isSuccess === 1) {
        closeShowPasswordModal();
      } else if (res?.data?.isSuccess === 2) {
        Swal.fire({
          showConfirmButton: true,
          text: res?.data?.msg[0],
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Ok'
        })
      }
    })
  }

  const closeShowPasswordModal = () => {
    setShowPassModal(false);
  }

  useEffect(() => {
    // console.log("isViewLocked ", clientDetails["clientDetails"]?.isViewLocked)
  }, [])

  return (
    <>
      {view === "list" && (
        <div className="bgmain h100">
          {/* HEADER START */}
          <div className="header">
            <div className="header-box">
              <div className="font-14 himg text-blue" onClick={props.toSettings}>
                <img
                  src="/images/back-arrow-blue.svg"
                  className="mr-1 settingheight"
                  alt=""
                />
              </div>
              <div className="header-name ">Ledger</div>
              <div
                className="himg font-14"
                onClick={() => {
                  setView("time");
                }}
              >
                <img
                  src="/images/clock.svg"
                  className="mr-1 settingheight"
                  alt=""
                />
              </div>
            </div>
          </div>
          {/* HEADER END */}
          {/* MIDDLE START */}
          {/* Message DATA START */}
          <div className="middle bgmain mt-0 ">
            {!!list ?
              <div className="settingbox min-h-whitebg">
                <div className="font-12 font-bold text-center mb-3">
                  From {moment(startDate).format('DD-MM-YYYY')} To {moment(endDate).format('DD-MM-YYYY')}
                </div>

                <div >
                  {list?.transactions?.length > 0 ? list?.transactions?.map((item) => {
                    return (
                      <>
                        <table className="table table-bordered font-12 table-strip w-100 mb-3 whitespace inviocetable">
                          <tbody>
                            <tr>
                              <td className="w-50">
                                <span className="text-grey font-bold f10 mr-1">
                                  Date:
                                </span>
                                <span className="text-black font-bold f10">
                                  {!!item?.ledgerDate ? moment(new Date(item?.ledgerDate + '+00:00').toLocaleString('sv-SE', { timeZone: serverTimeZone })).format('DD/MM/YY HH:mm:ss') : ''}
                                </span>
                              </td>
                              <td className="w-50">
                                <span className="text-grey font-bold f10 mr-1">
                                  Amount:
                                </span>
                                <span className={item.amount > 0 ? "font-bold f10 text-blue" : "font-bold f10 text-red"}>
                                  {!!item.amount ? item?.amount?.toFixed(2) : "0.00"}
                                </span>
                              </td>
                            </tr>
                            <tr>
                              <td className="w-50">
                                <span className="text-grey font-bold f10 mr-1">
                                  Type:
                                </span>
                                <span className="text-black font-bold f10">
                                  {item.transactionType}
                                </span>
                              </td>
                              <td className="w-50">
                                <span className="text-grey font-bold f10 mr-1">
                                  Remarks:
                                </span>
                                <span className="text-black font-bold f10 text-red">
                                  {item.remarks}
                                </span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </>
                    )
                  })
                    : <div className="nodatafound">No Data Found</div>}
                </div>
                <div className="ledgerbottonfixed">
                  <div className="text-center">
                    <div>Opening Amount</div>
                    <div>0.00</div>
                  </div>
                  <div className="text-center">
                    <div>Closing Amount</div>
                    <div>1000.00</div>
                  </div>
                </div>
              </div>
              : <div className="nodatafound">Please select ledger time period</div>}
          </div>
          {/* Message DATA END */}

          {/* MIDDLE END */}
          {/* FOOTER START */}

          {/* FOOTER END */}
        </div>
      )}
      {view === "time" && (
        <div className="bgmain h100 ">
          {/* HEADER START */}
          <div className="header">
            <div className="header-box">
              <div
                className="font-14 himg text-blue"
                onClick={() => {
                  setDateType("");
                  setView("list");
                }}
              >
                <img
                  src="/images/back-arrow-blue.svg"
                  className="mr-1 settingheight"
                  alt=""
                />
              </div>
              <div className="header-name "></div>
              <div
                className="himg font-14 text-blue"
                onClick={() => {
                  loadList();
                  setView("list");
                }}
              >
                Done
              </div>
            </div>
          </div>
          {/* HEADER END */}
          {/* MIDDLE START */}
          {/* Message DATA START */}
          <div>
            <table
              className="mb-30 w-100 tradesymlist"
              style={{ marginTop: "2px", backgroundColor: "white" }}
            >
              <tbody>
                <tr
                  onClick={() => {
                    setStartDate(moment(getPreviousDay()).format('YYYY-MM-DD'))
                    setEndDate(moment(new Date()).format("YYYY-MM-DD"));
                    setDateType("today");
                  }}
                >
                  <td className="w-75 text-black font-14">Today</td>
                  <td className="w-25 text-right">
                    {dateType === "today" && (
                      <i className="fa-solid fa-check font-16"></i>
                    )}
                  </td>
                </tr>
                <tr
                  onClick={() => {
                    setDateType("custom");
                  }}
                >
                  <td className="w-75 font-14 text-black">Custom</td>
                  <td className="w-25 text-right">
                    {dateType === "custom" && (
                      <i className="fa-solid fa-check font-16"></i>
                    )}
                  </td>
                </tr>
                {dateType === "custom" && (
                  <>
                    <tr>
                      <td className="w-75 font-14 text-black">Start Date</td>
                      <td className="w-25 text-right">
                        <input
                          type="date"
                          className="form-control"
                          value={startDate}
                          onChange={(e) => {
                            setStartDate(
                              moment(e.target.value).format("YYYY-MM-DD")
                            );
                          }}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td className="w-75 font-14 text-black">End Date</td>
                      <td className="w-25 text-right">
                        <input
                          type="date"
                          className="form-control"
                          value={endDate}
                          onChange={(e) => {
                            setEndDate(
                              moment(e.target.value).format("YYYY-MM-DD")
                            );
                          }}
                        />
                      </td>
                    </tr>
                  </>
                )}
              </tbody>
            </table>
          </div>
          {/* Message DATA END */}

          {/* MIDDLE END */}
          {/* FOOTER START */}

          {/* FOOTER END */}
        </div>
      )}
      <div className="login-popup">
        <Modal
          className="login passwordenter"
          show={showPassModal}
          onHide={() => closeShowPasswordModal()}
          backdrop="static"
          dialogAs={passModal}
          animation={false}
          size="sm"
          centered
        >
          <Modal.Header style={{ border: "none" }}>
          </Modal.Header>
          <Modal.Body
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div className="bgwhite">
              <h3 className={`text-center ${clientDetails["clientDetails"]?.isViewLocked ? "d-none" : ""}`}>Please enter your password</h3>
              <div className={`${clientDetails["clientDetails"]?.isViewLocked ? "text-danger" : ""}`}>This report represents sample ladger format. It contains sample data only fot education purpose. Ledger can be displayes in below structure.</div>
            </div>
            <div className={`position-relative mt-3 ${clientDetails["clientDetails"]?.isViewLocked ? "d-none" : ""}`}>
              <input
                type={`${showPass ? "text" : "password"}`}
                class="form-control"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <i class={`fa fa-eye${!showPass ? "-slash" : ""} password-check  remove_arrow_summary`} onClick={() => setShowPass(!showPass)}></i>
            </div>
            <div className={`mt-3 ${clientDetails["clientDetails"]?.isViewLocked ? "d-none" : ""}`}>
              <button type="button" class="buybtn w-100" onClick={() => submitPassword()}>Go</button>
            </div>
            <div className="mt-2">
              <button type="button" class="btnmain-danger btn btn-primary w-100" onClick={props.toSettings}>Go to Back</button>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
}